import React, { useState } from 'react';
import { Header } from '../components/Layout/Header';
import { Footer } from '../components/Layout/Footer';

const FAQPage: React.FC = () => {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  const faqs = [
    {
      question: "What is SuprHR?",
      answer: "SuprHR is a simple, AI-powered resume screening platform. We focus on ONE thing: helping you screen resumes against job descriptions quickly and efficiently. No ATS, no SSO, no complex onboarding - just simple, effective screening."
    },
    {
      question: "How fast can I start screening resumes?",
      answer: "You can screen your first resume in less than 30 seconds! Just create an account with email and password, upload a job description, upload resumes, and get instant AI analysis results."
    },
    {
      question: "How does the credit system work?",
      answer: "You purchase credits to process resumes. Each resume screening costs 1 credit. Credits don't expire and remain in your account until used. We offer different credit packages: Quick Charm, Focus Spell, and Wizard Mode with varying credit amounts."
    },
    {
      question: "What file formats do you support?",
      answer: "We support only text for job descriptions, and PDF for resumes."
    },
    {
      question: "How accurate is the AI screening?",
      answer: "Our AI provides detailed fitment scores and justifications by analyzing resumes against job descriptions. While AI analysis is highly sophisticated, we recommend using it as a screening tool to shortlist candidates, not as the sole hiring decision factor."
    },
    {
      question: "Can I get a refund if I'm not satisfied?",
      answer: "We maintain a no-refund policy for all credit purchases. Credits are consumed immediately when processing resumes, providing instant value. We encourage you to start with smaller packages to test our service before larger purchases."
    },
    {
      question: "Is my data secure?",
      answer: "Yes, we take data security seriously. All data is encrypted in transit and at rest. Resume content is used solely for AI analysis and is not shared with third parties. We use industry-standard security measures to protect your information."
    },
    {
      question: "How long does it take to process resumes?",
      answer: "Resume processing is typically completed within 3-5 seconds per resume. Processing time may vary based on resume length and complexity, but results are always delivered quickly."
    },
    {
      question: "Can I use SuprHR for multiple job positions?",
      answer: "Yes! You can create multiple job descriptions and screen resumes against different positions. Each job description is stored separately, and you can easily switch between them in your dashboard."
    },
    {
      question: "Do you offer customer support?",
      answer: "Yes, we provide customer support via email at contact@kautilya.app. We typically respond within 24 hours. We focus on simple, direct support without automated responses."
    }
  ];

  return (
    <div className="min-h-screen bg-base-200">
      <Header />

      {/* Content */}
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <div className="bg-base-100 rounded-lg shadow-lg p-8">
          <h1 className="text-3xl font-bold mb-6">Frequently Asked Questions</h1>
          <p className="text-base-content/70 mb-8">
            Find quick answers to common questions about SuprHR's resume screening service.
          </p>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="collapse collapse-arrow bg-base-200">
                <input
                  title={faq.question}
                  type="radio"
                  name="faq-accordion"
                  checked={openFAQ === index}
                  onChange={() => toggleFAQ(index)}
                />
                <div className="collapse-title text-xl font-medium">
                  {faq.question}
                </div>
                <div className="collapse-content">
                  <p className="text-base-content/80 leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="alert alert-info mt-8">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="stroke-current shrink-0 w-6 h-6">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            <span>Still have questions? <a href="/contact" className="link link-hover">Contact us</a> and we'll get back to you within 24 hours.</span>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default FAQPage; 